import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "image-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "product-details-container d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "product-name body-strong mb-1" }
const _hoisted_5 = { class: "station-name body-strong mb-1" }
const _hoisted_6 = { class: "product-dates m-0 caption text-grey-900" }
const _hoisted_7 = { class: "product-paricipants m-0 caption text-grey-900" }

import { computed, ComputedRef } from 'vue'

  // Configuration
  import { ModalId } from '@/config/modalIds'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Utils
  import { getImagePath } from '@/utils'

  // Store
  import { useStore } from '@/store'
  import { useI18n } from 'vue-i18n'
  interface Props {
    booking: BookingSummary
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PastBooking',
  props: {
    booking: {}
  },
  setup(__props: any) {

  // Vue
  const store = useStore()

  // Translations
  const { t, d } = useI18n()

  const props = __props

  // Copmuted
  const image: ComputedRef<string> = computed(() => {
    return getImagePath(props.booking.image as string)
  })

  // Methods

  const openPanel = () => {
    store.commit('modal/open', ModalId.BOOKING_PANEL)
    store.dispatch('booking/selectBooking', props.booking)
  }

return (_ctx: any,_cache: any) => {
  return (props.booking)
    ? (_openBlock(), _createElementBlock("article", {
        key: 0,
        class: "d-flex gap-3 p-1 col-12 col-md-6 mb-3 cursor-pointer",
        onClick: openPanel
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: image.value,
            alt: "lihe image"
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(props.booking.liheName), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(props.booking.stationName), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(d)(_ctx.booking.departureDate)) + " " + _toDisplayString(_unref(t)('reservations.until')) + " " + _toDisplayString(_unref(d)(_ctx.booking.returnDate)), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.booking.travellers.length) + " " + _toDisplayString(_unref(t)('reservations.participant', _ctx.booking.travellers.length)), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})